import { render } from "./MainMenu.vue?vue&type=template&id=4118662c&scoped=true&ts=true"
import script from "./MainMenu.vue?vue&type=script&lang=ts"
export * from "./MainMenu.vue?vue&type=script&lang=ts"

import "./MainMenu.vue?vue&type=style&index=0&id=4118662c&scoped=true&lang=css"
/* custom blocks */
import block0 from "./MainMenu.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "./MainMenu.vue?vue&type=custom&index=1&blockType=i18n&locale=fr"
if (typeof block1 === 'function') block1(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4118662c"]])

export default __exports__